<script lang="ts">
  import {HttpError} from "@tomra/client-side-http-client";

  interface Props {
    error: Error | string | unknown | null
  }

  let {error}: Props = $props()

  const extractHumanReadableHttpError = (err: HttpError) => {
    if (err.body && typeof err.body === 'object' && 'detail' in err.body && err.body.detail) {
      return err.body.detail
    }
    switch (err.status) {
      case 404:
        return 'Sorry, we could not find what you were looking for. This may be because the resource does not exist or has been removed.'
      default:
        return `${err.status} ${err.statusText}`
    }
  }

  let message: string = $derived.by(() => {
    if (error instanceof HttpError) {
      return `${extractHumanReadableHttpError(error)}
The operation could not be completed.
We are sorry for the inconvenience.`
    } else if (typeof error === 'string') {
      return error
    }
    return 'An unknown error occurred.'
  })
</script>

<div class="mt-2">
  <div class="alert alert-danger">
    {#each message.split('\n') as line, i (i)}
      {line}
      {#if i < message.split('\n').length - 1}
        <br>
      {/if}
    {/each}
  </div>
</div>